import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/format-utils'

export const countryColumn = {
  id: 'country',
  header: '#',
  accessorFn: (row) => row.country,
  cell: (row) => {
    const country = row.getValue()
    return <div>{country === 'all' ? 'All' : country}</div>
  },
  meta: {
    sticky: true,
    stickyLeft: 'left-[0px]',
  },
}

export const pidColumn = (p) => ({
  id: `pid-dr-${p.code}`,
  header: p.isGroup ? `${p.name} (Group)` : `${p.name}`,
  accessorFn: (row) => {
    const baseline = row.baselines?.[p.code]
    const dr = typeof baseline === 'object' ? baseline?.value : baseline
    const vs = row.vs?.[p.code]
    // 获取 single apps 子数据 (pid=14 时)
    const singleApps = row.baselines?.singleApps?.[p.code]
    return {
      pid: p.code,
      dr,
      vs,
      baseline,
      singleApps,
      country: row.country,
      isGroup: Boolean(p.isGroup),
    }
  },
  cell: (row) => {
    const { dr, vs, singleApps, isGroup } = row.getValue()
    const vsFormatted = formatNumber(vs, 2, 2)
    const hasSingleApps = singleApps && Object.keys(singleApps).length > 0

    // 如果dr和vs都不存在,返回null
    if ((dr === null || dr === undefined) && (vs === null || vs === undefined)) {
      return null
    }

    // 如果只有vs没有dr,只显示vs
    if (dr === null || dr === undefined) {
      return (
        <div className="text-right text-gray-400">
          -/{vsFormatted}
        </div>
      )
    }

    const differencePercentage = vs ? Math.abs(dr - vs) / vs : 0

    return (
      <div
        className={cn(
          'text-right',
          isGroup && 'bg-muted/30',
          hasSingleApps && 'cursor-pointer hover:bg-muted/50 rounded px-1',
          differencePercentage <= 0.1
            ? 'text-gray-400'
            : dr > vs
              ? 'text-destructive'
              : 'text-primary',
          differencePercentage > 0.1 ? 'font-bold' : '',
        )}
        title={
          isGroup
            ? 'Group baseline for aggregate ROI views only'
            : hasSingleApps
              ? 'Click to view single apps'
              : undefined
        }
      >
        {dr}/{vsFormatted}
        {hasSingleApps && (
          <span className="ml-1 text-xs text-muted-foreground">+</span>
        )}
      </div>
    )
  },
})
